<script>
    export let data;
    export let backColor = 'rgb(244, 244, 244)';
</script>

<div class="slider" style="width: 100vw;height: 50vw;overflow-y: scroll;">
    <div style="display:inline-flex;">
        {#each data as slider}
            <div class="slider_mobile_block">
                <div style="text-align:center;">
                    <div
                        style="width:25vw;height:25vw;border-radius:50%;margin:auto;margin-top: 2.5vw;"
                    >
                        <img src={slider.src} alt="" width="100%" style="border-radius: 50%;"/>
                    </div>
                    <div class="info" style="background-color:{backColor};">
                        <h1
                            style="font-size:3.889vw;color:black;font-weight:600;padding-top: 2vw;"
                        >
                            {slider.name}
                        </h1>
                        <h1
                            style="color:#7CC1FF;font-size:3.056vw;margin-bottom:0;"
                        >
                            {slider.about}
                        </h1>
                    </div>
                </div>
            </div>
        {/each}
    </div>
</div>

<style>
    .slider::-webkit-scrollbar {
        display: none;
    }
    .slider_mobile_block {
        position: relative;
        height: 48.611vw;
        width: 42.222vw;
        border: 0.833vw solid #7cc1ff;
        border-right: none;
        padding: 2vw;
    }
    .slider_mobile_block::after {
        content: "";
        width: 3.333vw;
        height: 3.333vw;
        background-color: #f7e05f;
        border-radius: 50%;
        position: absolute;
        bottom: -2vw;
        right: -2vw;
        z-index: 1;
    }
    .slider_mobile_block:nth-last-child(1)::after {
        content: "";
        background-color: transparent;
    }
    .slider_mobile_block:nth-child(1) {
        position: relative;
        height: 48.611vw;
        width: 14.7vw;
        border: 0.833vw solid #7cc1ff;
        padding: 0vw;
        border-left: none;
        border-right: none;
    }
    .slider_mobile_block:nth-last-child(1) {
        position: relative;
        height: 48.611vw;
        width: 26.7vw;
        border: 0.833vw solid #7cc1ff;
        padding: 0vw;
        border-right: none;
    }
    .info {
        height: 14.019vw;
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
    }
    .info:nth-child(1) {
        background-color: none;
        padding: 0;
        width: 0;
    }
</style>
